<mat-chip-row
  class="chip-material {{ styleClass() }} location-{{ location() }} outside-type-{{ outsideType() }}"
  [class.active]="items().length > 0"
  *ngFor="let item of items()"
  [removable]="true"
  [class.invalid-tag]="item?.isValid === false"
  [class.disabled]="item?.disabled"
  uTooltipPosition="above"
  [uTooltip]="showShortUrl() ? (item.isValid ? item.value || item.name : null) : null"
  (removed)="remove(item)"
>
  @if (location() === 'outside' && item.icon) {
    <u-icon [model]="iconModel(item)" [styles]="iconStyles()"> </u-icon>
  }
  @if (itemTemplate) {
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
  } @else {
    {{ showShortUrl() ? (item.value || item.name | shortUrl) : item.value || item.name }}
  }
  @if (!item.disabled) {
    <u-icon matChipRemove aria-label="Remove" [model]="{ type: 'font', value: 'icon-cross' }" [styles]="{ fontSize: '12px' }"></u-icon>
  }
</mat-chip-row>
